module.exports = __webpack_public_path__ + "img/lishigushi@3x.e61b4b93.png";